import { Fragment } from "react";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { Box, Grid, Typography } from "@mui/material";

import pages from "../../constants/pages";

const OuterBox = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 75vh;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 17px;
  box-sizing: border-box;
  background: #ffffff;
`;

const OuterPaper = styled(Box)`
  width: 100%;
  border-radius: 15px;
  min-height: 50vh;
  background: rgba(255, 255, 255, 0.5);
  align-content: center;
`;

const Img = styled("img")(({ theme }) => ({
  width: "22.5%",
  [theme.breakpoints.up("700")]: {
    width: "15%",
  },
}));

const OptionBox = styled(Grid)`
  background: black;
  color: black;
  width: 85%;
  height: 200px;
  justify-content: center;
  align-items: center;
  background: white;
  box-shadow: rgba(0, 0, 0, 0.72) 0px 0px 0px 3px;

  border-radius: 17.5px;
  margin-top: 35px;
  flex-direction: column;
  @media screen and (min-width: 800px) {
    flex-direction: row;
    justify-content: space-evenly;
    width: 45%;
  }
`;

export default function ShopsMore() {
  const navigate = useNavigate();

  return (
    <Fragment>
      <OuterBox>
        <OuterPaper>
          <Grid
            container
            justifyContent={"center"}
            sx={{
              "@media(min-width: 700px)": { justifyContent: "space-evenly" },
            }}
          >
            {[
              {
                name: "Hotels",
                logo: "https://dolphinchat-chat.s3.ap-south-1.amazonaws.com/publicURLS/a06ed04d3ab645418731c85668acecca/1729599122322_88973.png",
                click: function () {
                  navigate(pages.Hotels.route);
                },
              },
              {
                name: "Shops",
                logo: "https://dolphinchat-chat.s3.ap-south-1.amazonaws.com/publicURLS/a06ed04d3ab645418731c85668acecca/1729599094700_88981.png",
                click: function () {
                  navigate(pages.Shops.route);
                },
              },
            ].map((item, index) => {
              return (
                <OptionBox item container onClick={item.click}>
                  <Img src={item.logo} />
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: "900",
                      "-webkit-text-stroke-width": ".75px",
                      "@media(min-width: 700px)": {
                        fontSize: ".9rem",
                      },
                    }}
                  >
                    {item.name}
                  </Typography>
                </OptionBox>
              );
            })}
          </Grid>
        </OuterPaper>
      </OuterBox>
    </Fragment>
  );
}
